import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'

export const getDKTToken = (code, redirectUri) =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.token,
    params: {
      code: code,
      redirectUri: redirectUri,
    },
  })

export const atlanticLogin = (code: string, redirectUri: string) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.atlanticLogin,
    data: { code, redirectUri },
    hasLocale: false,
  })
